module.exports = __webpack_public_path__ + "132235d3f62da04c23a7d624bffec977.png";